import { render } from "./practicalTraining.vue?vue&type=template&id=20f370ca"
import script from "./practicalTraining.vue?vue&type=script&lang=js"
export * from "./practicalTraining.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__